import { SStyled } from 'styles/theme'
import SFlex from './opinionless/SFlex'
import { Image } from 'rebass'
import SBox from './opinionless/SBox'

export const Container = SStyled(SFlex)`
flex-direction: column;
background-color: ${(p) => p.theme.colors.secondaryColor};
overflow: hidden;
position: relative;
`

export const StyledPatternImage = SStyled(Image)`
position: absolute;
left: 0;
right: 0;
bottom: 0;
width: 100%;
object-fit: cover;
`

export const StyledF4GILogo = SStyled(Image)`
width: 100%;
height: auto;
z-index: 1;
object-fit: contain;
`

export const PolicyEngineLogo = SStyled(Image)`


width:100%;
z-index: 1;
object-fit: contain;
`

export const SocialIcons = SStyled(SFlex)`
margin-bottom: ${(p) => p.theme.space[4]}px;
`

export const LanguageSwitcherContainer = SStyled(SBox)<{ isAuthed: boolean }>`
    position: absolute;
    right: 24px;
    top: 20px;
    background-color: ${(p) =>
        p.isAuthed
            ? p.theme.colors.white
            : p.theme.colors.languageSwitcherInactiveColor || p.theme.colors.backgroundColor};
    border-radius: ${(p) => p.theme.radii[0]}px;
    overflow: hidden;
    z-index: 10;
`

export const RelativeContainer = SStyled(SBox)`
    position: relative;
    background-color: ${(p) => p.theme.colors.languageSwitcherInactiveColor}
`

export const HoverBox = SStyled(SBox)<{ left: number; width: number }>`
    background-color: ${(p) => p.theme.colors.languageSwitcherInactiveColor || p.theme.colors.secondaryColor};
    position: absolute;
    width: ${(p) => p.width}px;
    top: 0;
    bottom: 0;
    left: 0;
    transform: translateX(${(p) => p.left}px);
    z-index: 1;
    border-radius: ${(p) => p.theme.radii[0]}px;
    transition: transform 0.1s ease-out;
`

export const RelativeContainerTabSwitcher = SStyled(SBox)`
position: relative;
width: 100%;
display: flex;
background-color: ${(p) => p.theme.colors.gray200};
margin-bottom: ${(p) => p.theme.space[10]}px;
border-radius: ${(p) => p.theme.radii[3]}px;
`

export const NavBarContainer = SStyled(SFlex)`
    height: 90px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: ${(p) => p.theme.breakpoints[0]}px;
    border-bottom: 1px solid ${(p) => p.theme.colors.black};
    margin: auto;
`

export const NavBarStyledLogo = SStyled(SBox)`
    flex: 0 0 60px;
    height: 60px;
    border-radius: 60px;
    background-color: black;
    overflow: hidden;
`
